
import { URLS } from '../constants'
import {
    GET_ALL_APPLICATION_SERVICES_BEGIN, GET_ALL_APPLICATION_SERVICES_SUCCESS, GET_ALL_APPLICATION_SERVICES_FAILURE,
    POST_APPLICATION_SERVICE_BEGIN, POST_APPLICATION_SERVICE_SUCCESS, POST_APPLICATION_SERVICE_FAILURE
} from '../constants/ActionTypes'

import { dispatchFetchGet, dispatchFetchPostFormData } from './ActionUtil'

// Get All Application Services
const acGetAllApplicationServicesBegin = () => ({ type: GET_ALL_APPLICATION_SERVICES_BEGIN })
const acGetAllApplicationServicesSuccess = data => ({ type: GET_ALL_APPLICATION_SERVICES_SUCCESS, payload: data })
const acGetAllApplicationServicesFailure = err => ({ type: GET_ALL_APPLICATION_SERVICES_FAILURE, payload: err })

/**
 * @description Retrieves all application services.
 *
 * @author Maria Eduarda Franke
 */
export const acGetAllApplicationServices = () => {
    return dispatchFetchGet(
        URLS.APPLICATION_SERVICES,
        acGetAllApplicationServicesBegin,
        acGetAllApplicationServicesSuccess,
        acGetAllApplicationServicesFailure
    )
}

// Post Application Service
const acPostApplicationServiceBegin = () => ({ type: POST_APPLICATION_SERVICE_BEGIN })
const acPostApplicationServiceSuccess = data => ({ type: POST_APPLICATION_SERVICE_SUCCESS, payload: data })
const acPostApplicationServiceFailure = err => ({ type: POST_APPLICATION_SERVICE_FAILURE, payload: err })

/**
 * @description Dispatches a POST request to create an application service.
 *
 * @author Maria Eduarda Franke
 */
export const acPostApplicationService = applicationService => {
    return dispatchFetchPostFormData(
        URLS.APPLICATION_SERVICES,
        applicationService,
        acPostApplicationServiceBegin,
        acPostApplicationServiceSuccess,
        acPostApplicationServiceFailure
    )
}